export default __webpack_public_path__ + "static/media/discord.0f24a400.svg";